(function () {
  if (window.__covaSwatches) return;
  window.__covaSwatches = true;

  function setText(el, txt) { if (el) el.textContent = txt; }

  function select(btn) {
    var wrap = btn.closest('[data-cova-sw]');
    var card = btn.closest('.card-wrapper');
    if (!wrap || !card) return;

    wrap.querySelectorAll('.cova-sw__btn').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    var img = card.querySelector('.card__media .media img');
    if (img && img.parentElement) { img.parentElement.classList.add('cova-picked'); img.parentElement.classList.remove('cova-alt'); }
    if (img && btn.dataset.src && img.getAttribute('src') !== btn.dataset.src) {
      var pre = new Image();
      img.classList.add('cova-fade');
      pre.onload = pre.onerror = function () {
        img.removeAttribute('srcset');
        img.src = btn.dataset.src;
        if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
        img.classList.remove('cova-fade');
      };
      pre.src = btn.dataset.src;
    }

    var box = card.querySelector('.price');
    if (box && btn.dataset.price) {
      var compare = btn.dataset.compare || '';
      box.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale, .price__sale .price-item--last').forEach(function (el) { setText(el, btn.dataset.price); });
      var s = box.querySelector('.price__sale s.price-item--regular');
      if (s && compare) setText(s, compare);
      box.classList.toggle('price--on-sale', !!compare);
    }

    var input = card.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var submit = card.querySelector('form[data-type="add-to-cart-form"] [name="add"]');
    var available = btn.dataset.available === 'true';
    if (input) { input.value = btn.dataset.id; input.disabled = !available; }
    if (submit) {
      submit.disabled = !available;
      var label = submit.querySelector('span');
      if (label) {
        if (!submit.dataset.covaAtc) submit.dataset.covaAtc = label.textContent.trim();
        label.textContent = available ? submit.dataset.covaAtc : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      }
    }

    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try { var u = new URL(a.href, location.origin); u.searchParams.set('variant', btn.dataset.id); a.href = u.pathname + u.search; } catch (e) {}
    });
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-cova-more]');
    if (more) { e.preventDefault(); more.closest('[data-cova-sw]').classList.add('is-open'); return; }
    var btn = e.target.closest('.cova-sw__btn');
    if (btn) { e.preventDefault(); select(btn); }
  });

  function warm(e) {
    var btn = e.target.closest && e.target.closest('.cova-sw__btn');
    if (btn && btn.dataset.src && !btn.dataset.warm) { btn.dataset.warm = 1; (new Image()).src = btn.dataset.src; }
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
})();

/* COVA: touch - press & hold shows 2nd image, horizontal swipe flips it */
(function () {
  if (window.__covaFlip) return; window.__covaFlip = true;
  if (!('ontouchstart' in window)) return;

  function mediaOf(card) {
    var m = card && card.querySelector('.card__media .media--hover-effect');
    return m && m.querySelectorAll('img').length > 1 && !m.classList.contains('cova-picked') ? m : null;
  }
  function setAlt(m, on) {
    m.classList.toggle('cova-alt', on);
    var d = m.parentElement.querySelector('.cova-dots');
    if (d) { d.children[0].classList.toggle('on', !on); d.children[1].classList.toggle('on', on); }
  }
  function addDots() {
    document.querySelectorAll('.card__media .media--hover-effect').forEach(function (m) {
      if (m.dataset.dots || m.querySelectorAll('img').length < 2) return;
      m.dataset.dots = 1;
      var d = document.createElement('div'); d.className = 'cova-dots'; d.innerHTML = '<i class="on"></i><i></i>';
      m.parentElement.appendChild(d);
    });
  }
  addDots();
  document.addEventListener('DOMContentLoaded', addDots);
  var mq = 0; new MutationObserver(function () { if (mq) return; mq = requestAnimationFrame(function () { mq = 0; addDots(); }); }).observe(document.documentElement, { childList: true, subtree: true });

  var st = null, holdT = null, block = false;
  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest('.card-wrapper'); if (!card) return;
    var inner = card.querySelector('.card__inner'); if (!inner) return;
    var t = e.touches[0], r = inner.getBoundingClientRect();
    if (t.clientY > r.bottom || t.clientY < r.top) return;
    var m = mediaOf(card); if (!m) return;
    st = { m: m, x: t.clientX, y: t.clientY, was: m.classList.contains('cova-alt'), moved: false, held: false };
    holdT = setTimeout(function () { if (st && !st.moved) { st.held = true; block = true; setAlt(st.m, !st.was); } }, 280);
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!st) return;
    var t = e.touches[0], dx = t.clientX - st.x, dy = t.clientY - st.y;
    if (Math.abs(dx) > 10 || Math.abs(dy) > 10) { st.moved = true; clearTimeout(holdT); }
    if (!st.swiped && Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.4) {
      st.swiped = true; block = true; setAlt(st.m, dx < 0);
    }
  }, { passive: true });

  document.addEventListener('touchend', function () {
    clearTimeout(holdT);
    if (st && st.held) setAlt(st.m, st.was);
    st = null;
    if (block) setTimeout(function () { block = false; }, 400);
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (block && e.target.closest('.card-wrapper')) { e.preventDefault(); e.stopPropagation(); block = false; }
  }, true);
  document.addEventListener('contextmenu', function (e) { if (e.target.closest('.card-wrapper .card__inner, .card-wrapper .card__media')) e.preventDefault(); });
})();
